import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import styles from './TransactionsList.module.scss';
import Trash from '../../assets/icons/Trash_Empty.svg';

const formatAmount = (amount) => {
  const num = Number(amount);
  if (!Number.isFinite(num)) return '0';
  return num.toLocaleString('ru-RU');
};

const pad2 = (n) => String(n).padStart(2, '0');

const renderDescription = (text, onHashtagClick) => {
  if (!text || !text.trim()) return '—';

  const parts = text.split(/(#[а-яА-ЯёЁa-zA-Z0-9_]+)/g);

  return parts.map((part, i) => {
    if (part.startsWith('#')) {
      return (
        <span
          key={i}
          className={styles.hashtag}
          onClick={(e) => {
            e.stopPropagation();
            onHashtagClick?.(part);
          }}>
          {part}
        </span>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

export default function TransactionBlock({ t, onDelete, onHashtagClick }) {
  const isIncome = t.type === 'income';
  const sign = isIncome ? '+' : '−';

  const d = new Date(t.occurred_at || t.created_at);
  const time = Number.isFinite(d.getTime())
    ? `${pad2(d.getHours())}:${pad2(d.getMinutes())}`
    : '';

  const [confirmDel, setConfirmDel] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (!confirmDel) return;
    const tm = setTimeout(() => setConfirmDel(false), 2500);
    return () => clearTimeout(tm);
  }, [confirmDel]);

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (!onDelete) return;

    if (!confirmDel) {
      setConfirmDel(true);
      return;
    }

    setConfirmDel(false);
    onDelete(t.id);
  };

  return (
    <motion.div
      layout
      style={{ minWidth: 0 }}
      initial={{ opacity: 0, scale: 0.98, y: 6 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.98, y: -6 }}
      transition={{ duration: 0.18 }}>
      <div
        className={[
          styles.transaction__block,
          isIncome
            ? styles['transaction__block--income']
            : styles['transaction__block--expense'],
        ].join(' ')}>
        <div className={styles.transaction__header}>
          <div className={styles.transaction__category}>
            {t.category_name || '—'}
          </div>

          <div className={styles.transaction__cost}>
            {sign}
            {formatAmount(t.amount)}
            <span className={styles.transaction__rub}>₽</span>
          </div>
        </div>

        <div 
          className={styles.transaction__description}
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
        >
          <span 
            className={[
              styles.transaction__descText,
              isExpanded ? styles['transaction__descText--expanded'] : ''
            ].join(' ')}
          >
            {renderDescription(t.description, onHashtagClick)}
          </span>
        </div>

        <div className={styles.transaction__date}>{time}</div>

        {onDelete ? (
          <button
            type='button'
            className={[
              styles.transaction__del,
              confirmDel ? styles['transaction__del--confirm'] : '',
            ].join(' ')}
            onClick={handleDeleteClick}
          >
            <img
              src={Trash}
              alt=''
              className={styles['transaction__del--icon']}
            />
            {confirmDel ? 'Подтвердить' : 'Удалить'}
          </button>
        ) : null}
      </div>
    </motion.div>
  );
}